// extracted by mini-css-extract-plugin
export default {"Policy":"Policy___ZwR_g","PolicyGrammarName":"PolicyGrammarName___aJMDQ"};